export const AD_DETAILS = 'ad_intelligence/ad_details';
export const AD_INTELLIGENCE_CREATIVES = 'ad_intelligence/creatives';
export const AD_INTELLIGENCE_CREATIVES_RISKY = 'ad_intelligence/creatives/risky';
export const AD_INTELLIGENCE_CREATIVES_COMPETITOR = 'ad_intelligence/creatives/competitors';

export const CAMPAIGN_DETAILS = 'ad_intelligence/campaign_details';
export const AD_INTELLIGENCE_CAMPAIGNS = 'ad_intelligence/campaigns';
export const AD_INTELLIGENCE_REPORT_AD = 'ad_intelligence/report_ad';

export const CUSTOMER_FLAGGED_CATEGORY = 'customer_flagged_category';
export const COMPETITOR = 'competitor';
export const RISKY_CONTENT = 'risky_content';
export const MANAGE_RISKY_CONTENT = 'MANAGE_RISKY_CONTENT';
export const MANAGE_COMPETITORS = 'MANAGE_COMPETITORS';

export const RISKY_CONTENT_SAVED_NOTIFICATION_MESSAGE = 'Risky Content preferences saved successfully';
export const RISKY_CONTENT_NOT_SAVED_NOTIFICATION_MESSAGE = 'Failed to save Risky Content preferences';
export const RULE_SAVED_NOTIFICATION_MESSAGE = 'rule saved successfully';
export const RULE_UPDATED_NOTIFICATION_MESSAGE = 'rule updated successfully';
export const RULE_DELETED_NOTIFICATION_MESSAGE = 'rule deleted successfully';
export const COMPETITOR_RULE_SAVED_NOTIFICATION_MESSAGE = 'Competitor Rule saved/updated/deleted successfully';
export const RULE_NOT_SAVED_NOTIFICATION_MESSAGE = 'Failed to save the rule';

export const CONTENT_PREFERENCES_TITLE = 'Content Preferences:';
export const RULES_TILE = 'Rules:'
export const RISKY_RULES_TILE = 'Risky Rules:'
export const COMPETITOR_RULES_TILE = 'Competitor Rules:'

export const SPECIAL_HASH_KEY = 'prev';

export const RISKY_CONTENT_PREFERENCES = {
    label: 'Risky Content Preferences',
    key: 'preferences'
};

export const RISKY_CONTENT_RULES = {
    label: 'Risky Content Rules',
    key: 'rules'
};

export const RISKY_CONTENT_DATA_TYPE = {
    [RISKY_CONTENT_RULES.key]: RISKY_CONTENT,
    [RISKY_CONTENT_PREFERENCES.key]: CUSTOMER_FLAGGED_CATEGORY
};

export const columnEndpoint = (reportId: string) => `advanced_reports/reports/${reportId}/column`;

export enum Filters {
    ACCOUNT = 'account',
    AD_FORMATS = 'ad_formats',
    ADVISORIES = 'advisories',
    ADVERTISER = 'advertiser',
    APPLICATION = 'app',
    COMPETITOR_RULES = 'competitor_rules',
    CONTENT_RATING = 'content_rating',
    COUNTRY = 'country',
    CREATIVE_ID = 'creative_id',
    CREATIVE_TYPE = 'creative_types',
    NETWORK = 'max_network',
    PLATFORM = 'platform',
    REPORTED_STATUS = 'reported_status',
    RISKY_CATS = 'risky_cats',
    RISKY_CATEGORY = 'risky_category',
    RISKY_CONTENT = 'special_filter',
    RISKY_RULES = 'risky_rules',
    SPECIAL = 'special',
    STORE_CATEGORIES = 'store_categories',
    TITLE = 'title',
    WEBSITE = 'website',
    CONTENT_CATEGORY_SPECIAL = 'content_category_special'
}

export const IMPRESSION_INTEL_REPORT_TITLE = {
    regular: 'Creative Reporting',
    advanced: 'Impression Intel'
}

export const ADVANCED_REPORTS_MODULE_URL_PREFIX = '/v1/advanced_reports';

export const FILTER_SOURCE_INFO = 'info';
export const FILTER_SOURCE_SERVER = 'server';

export enum PageFamilyType {
    CAMPAIGNS,
    CREATIVES
};

export enum HTTP_METHOD {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
};

export const TYPE_OPTION_VALUES = {
    TITLE: 'title',
    DEVELOPER: 'developer',
    GENRE: 'genre',
    CONTENT_RATING: 'content_rating',
    ADVISORY: 'advisory',
    WEB_DOMAIN: 'web_domain',
    SIMILAR_APP: 'similar_apps',
    STORE_CATEGORY: 'store_category',
    ADVERTISER: 'advertiser'

}
export const TYPE_OPTION_SERVER_KEYS = {
    TITLES: 'titles',
    ADVERTISERS: 'advertisers',
    CONTENT_RATINGS: 'content_ratings',
    ADVISORIES: 'advisories',
    WEB_DOMAINS: 'web_domains',
    COUNTRIES: 'countries',
    USER_EMAILS: 'user_emails',
    SIMILAR_APPS: 'similar_apps',
    STORE_CATEGORIES: 'store_categories'
}

export type RiskyCategory = {
    key: string
    label: string
    description: string
}

export const RISKY_CATEGORIES: Partial<RiskyCategory>[] = [
    { key: 'is_adult', description: 'Ads that promote, depict, or strongly imply sexually explicit, sexualized, or adult-oriented content, where the primary intent is sexual arousal, gratification, or the promotion of adult sexual services or products.' },
    { key: 'is_adult_anime', description: 'Ads that depict sexualized or explicit adult content using animated, cartoonish, or anime-style characters, where sexualization is the primary intent.' },
    { key: 'is_betting', description: 'Apps or websites that allow users to wager real money or items of monetary value on games of chance or skill, with the ability to win or lose real money or redeem winnings.' },
    { key: 'is_money_offer', description: 'Ads that promote immediate access to money, credit, or "fast funding", or promote high-risk/restricted financial products that can be predatory, too-good-to-be-true, or speculative.' },
    { key: 'is_violence', description: 'Ads that contain or promote violence, threats of violence, physical or mental harm, terrorism, weapons, or horror imagery, including realistic or real-world depictions involving people, animals, or property.' },
    { key: 'is_harassment', description: 'Ads that include verbal harassment, bullying, intimidation, threats, hate speech, discrimination, or explicit profanity. causing psychological, emotional, or reputational harm (not physical violence).' },
    { key: 'is_disturbing_visuals', description: 'Ads that contain or imply shocking, disturbing, grotesque, or offensive visuals, audio, or language that may cause discomfort, disgust, or emotional distress to viewers.' },
    { key: 'is_political', description: 'Ads that reference, promote, oppose, or attempt to influence political actors, elections, or government decision-making. This includes political candidates, parties, elected/appointed officials, election-related activity, and advocacy on political issues or outcomes.' },
    { key: 'is_misleading', description: 'Ads that make misleading, deceptive, false, or unrealistic claims, omit critical information, or use dishonest tactics to manipulate users\' decisions, behavior, or trust.' },
    { key: 'is_alcohol', description: 'Ads that promote, sell, depict, or are primarily about alcoholic beverages or alcohol-related consumption, including the branding, sale, delivery, or promotion of alcohol.' },
    { key: 'is_tobacco_smoking', description: 'Ads that promote, sell, depict, or are primarily about smoking-related products or behaviors, including tobacco and nicotine use, smoking or vaping devices, and accessories designed to enable smoking or inhalation.' },
    { key: 'is_illegal_drugs', description: 'Ads that promote, sell, depict, imply, or normalize illegal drugs, drug paraphernalia, substance abuse, or drug culture, including cannabis and THC-related products, as well as any content that glamorizes, glorifies, or encourages being "high" or intoxicated.' },
    { key: 'is_religious', description: 'Ads featuring religious subjects or services provided by religious institutions.' }
];

export const COMPETITORS_TYPE_OPTIONS = [
    {
        label: 'Store Category', value: TYPE_OPTION_VALUES.STORE_CATEGORY,
        server_key: TYPE_OPTION_SERVER_KEYS.STORE_CATEGORIES, showMoreMessage: true
    },
    {
        label: 'Similar apps', value: TYPE_OPTION_VALUES.SIMILAR_APP,
        server_key: TYPE_OPTION_SERVER_KEYS.SIMILAR_APPS, showMoreMessage: true, isHidden: true
    },
    {
        label: 'Title', value: TYPE_OPTION_VALUES.TITLE,
        server_key: TYPE_OPTION_SERVER_KEYS.TITLES, showMoreMessage: true
    },
    {
        label: 'Advertiser', value: TYPE_OPTION_VALUES.ADVERTISER, server_key:
            TYPE_OPTION_SERVER_KEYS.ADVERTISERS, showMoreMessage: true
    }


];
export const RISKY_CONTENT_TYPE_OPTIONS = [
    {
        label: 'Title', value: TYPE_OPTION_VALUES.TITLE,
        server_key: TYPE_OPTION_SERVER_KEYS.TITLES, showMoreMessage: true
    },
    {
        label: 'Advertiser', value: TYPE_OPTION_VALUES.ADVERTISER, server_key:
            TYPE_OPTION_SERVER_KEYS.ADVERTISERS, showMoreMessage: true
    },
    {
        label: 'Store Category', value: TYPE_OPTION_VALUES.STORE_CATEGORY, server_key:
            TYPE_OPTION_SERVER_KEYS.STORE_CATEGORIES
    },
    {
        label: 'Content Rating', value: TYPE_OPTION_VALUES.CONTENT_RATING, server_key:
            TYPE_OPTION_SERVER_KEYS.CONTENT_RATINGS
    },
    {
        label: 'Advisory', value: TYPE_OPTION_VALUES.ADVISORY, server_key:
            TYPE_OPTION_SERVER_KEYS.ADVISORIES
    },
    {
        label: 'Website', value: TYPE_OPTION_VALUES.WEB_DOMAIN, server_key:
            TYPE_OPTION_SERVER_KEYS.WEB_DOMAINS, showMoreMessage: true
    },
];

export const RULES_TYPE_OPTION = {
    [COMPETITOR]: COMPETITORS_TYPE_OPTIONS,
    [RISKY_CONTENT]: RISKY_CONTENT_TYPE_OPTIONS
}

export const RULES_NAME_PLACEHOLDER = 'Enter Rule Name';

export const AUTO_GENERATED_RULE_TOOLTIP = 'This is an auto-generated rule.';

export const ANDROID_PLATFORM = {
    label: 'Android',
    key: 'android'
}

export const IOS_PLATFORM = {
    label: 'iOS',
    key: 'ios'
}

export const WEB_PLATFORM = {
    label: 'Web',
    key: 'web'
}

export const PLATFORM_LABEL = {
    [ANDROID_PLATFORM.key]: ANDROID_PLATFORM.label,
    [IOS_PLATFORM.key]: IOS_PLATFORM.label,
    [WEB_PLATFORM.key]: WEB_PLATFORM.label
}

export const UJ_AD_TYPES = {
    banner: 'Banner',
    interstitial: 'Interstitial',
    rewarded: 'Rewarded',
    'app open': 'App Open',
    mrec: 'MREC',
    native: 'Native'
}

export const UJ_AD_TYPES_ADAPTER = {
    banner: 'banner',
    inter: 'interstitial',
    reward: 'rewarded',
    'appopen': 'app open',
    mrec: 'mrec',
    native: 'native'
}

export const UJ_AD_TYPES_REVERSE_ADAPTER = Object.keys(UJ_AD_TYPES_ADAPTER).reduce((object, key) => {
    object[UJ_AD_TYPES_ADAPTER[key]] = key;

    return object;
}, {})

export enum AD_TYPE {
    FULL_SCREEN = 'fullscreen',
    BANNER = 'banner',
    MREC = 'mrec',
    NATIVE = 'native'
};

export const FULL_SCREEN_CREATIVES = {
    label: 'Full Screen',
    key: 'fullscreen'
};
export const BANNER_CREATIVES = {
    label: 'Banners',
    key: 'banner'
}
export const MREC_CREATIVES = {
    label: 'MREC',
    key: 'mrec'
}
export const NATIVE_CREATIVES = {
    label: 'Native',
    key: 'native'
}

export const BANNER = 'BANNER';
export const BANNERS = 'Banners'
export const MORE_DATA_TEXT = "+more";
export const COMPETITORS_CATEGORY = "Competitors"
export const INAPPROPRIATE_CONTENT_CATEGORY = "Inappropriate content"

export const DATA_AND_EMAILS_DISPLAY = {
    OPTIONS: {
        DATA_ONLY: 'only_data',
        SELECTION_ONLY: 'only_selection',
        DATA_AND_SELECTION: 'data_and_selection'
    },
    shouldDisplayEmails: param => param === DATA_AND_EMAILS_DISPLAY.OPTIONS.SELECTION_ONLY || param === DATA_AND_EMAILS_DISPLAY.OPTIONS.DATA_AND_SELECTION,
    shouldDisplayData: param => param === DATA_AND_EMAILS_DISPLAY.OPTIONS.DATA_ONLY || param === DATA_AND_EMAILS_DISPLAY.OPTIONS.DATA_AND_SELECTION
};

export const MatchingDataReportTitle = 'Matching Data Report';

export enum ReportId {
    CREATIVES = 'creatives_data',
    RISKY_CREATIVES = 'risky_creatives',
    COMPETITOR_CREATIVES = 'competitor_creatives',
}

export const PAGES_PROPS = {
    creatives: {
        title: 'Creatives',
        reportId: ReportId.CREATIVES,
        key: 'creatives'
    },
    risky_creatives: {
        title: 'Risky Content',
        reportId: ReportId.RISKY_CREATIVES,
        key: 'risky_creatives'
    },
    competitor_creatives: {
        title: 'Competitors',
        reportId: ReportId.COMPETITOR_CREATIVES,
        key: 'competitors'
    },
    creative_details: {
        title: '',
        type: 'creative',
        key: 'creative_details',
        showReportAdButton: true,
        detailsUrl: AD_DETAILS as typeof AD_DETAILS,
        imagesSliderPrefix: "Selected Creative",
    },
    campaign_details: {
        title: 'Campaign Details',
        type: 'campaign',
        key: 'campaign_details',
        showReportAdButton: false,
        isCampaignsData: true,
        detailsUrl: CAMPAIGN_DETAILS as typeof CAMPAIGN_DETAILS,
        imagesSliderPrefix: "",
    },
    campaigns: {
        title: 'Campaigns',
        key: 'campaigns',
    },
    // review
    autoRedirects: {
        title: 'Auto Redirects',
        key: 'autoRedirects',
    },
    autoRedirectsSearch: {
        title: 'Auto Redirects Search',
        key: 'autoRedirectsSearch',
    },
    intelImpressionReport: {
        title: '',
        key: 'intelImpressionReport',
    },
    // manage pages
    riskyForm: {
        title: 'Risky Content',
        key: 'riskyForm',
        subtitle: '',
    },
    competitors: {
        title: 'Competitor Rules',
        key: 'competitors',
        breadcrumbLabelNew: 'Create New Competitor Rule',
    },
    riskyContent: {
        title: 'Risky Content Settings',
        key: 'risky_content',
        breadcrumbLabelNew: 'Create New Risky Rule',

    }
}

export const ALERTS_MAPPING = {
    click: {
        icon: require('../assets/images/click.svg'),
        label: () => 'Network SDK indicated that the user clicked this ad',
        condition: () => false
    },
    restart: {
        icon: require('../assets/images/restart.svg'),
        label: () => 'App restarted while impression was showing',
        condition: () => false
    },
    'auto_redirect': {
        icon: require('../assets/images/auto-redirect.svg'),
        label: () => 'User was automatically redirected outside the app while impression was showing',
        condition: () => false
    },
    inappropriate: {
        icon: require('../assets/images/Inappropriate.svg'), label: () => 'Risky Content',
        condition: (e) => {
            return !!e.is_inappropriate || (e.inappropriate_categories && e.inappropriate_categories.length > 0);
        }
    },
    report: {
        icon: require('../assets/images/Report.svg'), label: () => 'Reported',
        condition: (e) => {
            // in campaign_details, only reports key is available which is an array of report objects ({at:..., from:..., to:..., cc:...})
            return e.isReported || e.adReports || e.reports?.length || (e.reportedStatus === 'yes');
        }
    },
    competitors: {
        icon: require('../assets/images/Watchlist.svg'),
        label: () => 'Competitor',
        condition: (e) => {
            return e.is_competitor;
        }
    },
}

export const PANGLE_TOOLTIP = 'Pangle video links are\nlimited in time. Once\nexpired, the video can not\nbe played.';

export const LOADING_MESSAGE = 'Loading...';

export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const SELECT_USER_TEXT = 'Please filter by a specific account to see the results';

export const SELECT_USER_BUTTON_TEXT = 'Please filter by a specific account to enable this button';